import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const useFeatureFlag = (flag: string): boolean => {
  const flags = useSelector((state: RootState) => state.auth.featureFlags);
  // Handle undefined flags object (before API call completes)
  if (!flags) return false;
  return flags[flag] || false;
};

/**
 * Hook to check if ANY of the provided feature flags are enabled (OR logic)
 * @param flagsArray - Array of feature flag names to check
 * @returns true if at least one flag is enabled, false otherwise
 */
export const useFeatureFlags = (flagsArray: string[]): boolean => {
  const flags = useSelector((state: RootState) => state.auth.featureFlags);
  // Handle undefined flags object (before API call completes)
  if (!flags || !flagsArray || flagsArray.length === 0) return false;
  
  // Return true if ANY flag is enabled (OR logic)
  return flagsArray.some(flag => flags[flag] || false);
};

